import { StatusType } from "./types";

/** Represents a point in cartesian coordinate space. */
export class Point {
  constructor(
    /** The location of the point along the x-axis. */
    public x: number,
    /** The location of the point along the y-axis. */
    public y: number,
  ) { }
}

/** Represents a set of bounds for a given type. */
export class Bounds<T> {
  constructor(
    /** The lower valued portion of the bounds. */
    public lower: T,
    /** The higher valued portion of the bounds. */
    public higher: T,
  ) { }
}

export type RadianBounds = {
  [K in StatusType]: Bounds<number>
};
